import { render, staticRenderFns } from "./AUDAuditoriaViagens.vue?vue&type=template&id=10c39ca5&scoped=true&"
import script from "./AUDAuditoriaViagens.vue?vue&type=script&lang=js&"
export * from "./AUDAuditoriaViagens.vue?vue&type=script&lang=js&"
import style0 from "./AUDAuditoriaViagens.vue?vue&type=style&index=0&id=10c39ca5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c39ca5",
  null
  
)

export default component.exports